export const getPageSubnav = (projectId: string, ref: string) => (
  [
    { title: 'Page details', to: `/project/${projectId}/visitor-info/${ref}` },
    { title: 'Translations', to: `/project/${projectId}/visitor-info/${ref}/translations` },
  ]
)

export const getAmenitySubnav = (projectId: string, ref: string) => (
  [
    { title: 'Page details', to: `/project/${projectId}/visitor-info/amenity/${ref}` },
    { title: 'Translations', to: `/project/${projectId}/visitor-info/amenity/${ref}/translations` },
  ]
)
